import AttachmentsModalComponent from './attachments-modal.component'

const AttachmentsModalModule = angular.module('cdbl.attachments.attachments-modal', [

])
  .component('cdblAttachmentsModal', AttachmentsModalComponent)
  .name

export default AttachmentsModalModule
